"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobReader = void 0;
// browser reader for Blob|File objects
class BlobReader {
    constructor(blob) {
        if (!(blob instanceof Blob)) {
            throw new Error("Expected file to be a File or Blob.");
        }
        this._blob = blob;
        this._size = blob.size;
    }
    async open() {
        return this._size;
    }
    /**
     * Read `length` bytes starting from `offset` bytes.
     */
    async read(offset, length) {
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function () {
                reader.onload = null;
                reader.onerror = null;
                if (reader.result == undefined || !(reader.result instanceof ArrayBuffer)) {
                    return reject("Unsupported format for BlobReader");
                }
                resolve(new Uint8Array(reader.result));
            };
            reader.onerror = function () {
                reader.onload = null;
                reader.onerror = null;
                reject(reader.error ?? new Error("Unknown FileReader error"));
            };
            reader.readAsArrayBuffer(this._blob.slice(offset, offset + length));
        });
    }
    size() {
        return this._size;
    }
}
exports.BlobReader = BlobReader;
//# sourceMappingURL=BlobReader.js.map